
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.IdleGps = {

  template() {
    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.lategps.timeinterval'),
                  attributes: {
                    'class': 'i18nResource',
                  },
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'idle_gps_timeIntervalMinutes',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    'type': 'text',
                    'name': 'idle_gps_timeIntervalMinutes',
                    maxlength: '10',
                    'alt': '',
                    value: '',
                    size: '11',
                    id: 'idle_gps_timeIntervalMinutes',
                    class: 'modelAttribute textField numberPicker mandatory',
                    autocomplete: 'off',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'checkbox',
                    id: 'idle_gps_check_route_status',
                    'class': 'modelAttribute checkbox',
                  },
                },
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.check.IdleGPS.checkRouteStatus'),
                  attributes: {
                    'style': 'margin-left: 5px'
                  }
                }
              ],
              attributes: {
                class: 'controls',
                'style': 'margin-top: 5px'
              },
            }
          ],
          attributes: {
            class: 'control-group',
          },
        },
      ],
    };
  },

  assignParameter(jsonParam) {
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);

      $('#idle_gps_timeIntervalMinutes').val(jsonParam.minutesInterval);
      document.getElementById('idle_gps_check_route_status').checked = jsonParam.checkRouteStatus;
    }
  },
  retrieveParameter() {
    const timeMinutes = parseInt($('#idle_gps_timeIntervalMinutes').val(), 10);
    const checkRouteStatus = document.getElementById('idle_gps_check_route_status').checked;

    return JSON.stringify({
      minutesInterval: timeMinutes,
      checkRouteStatus: checkRouteStatus
    });
  },

};
